module.exports = __webpack_public_path__ + "img/list_3.53d0dc7c.jpg";